'use strict'

let definition=require('../../definition/labels/english.js').english;

export let english={
  general: {
    output: "output",
    approach: "Approach",
    scope: definition.scope.fields.projectScope.title
  },
  outputSummary: {
    cover: "To cover",
    projectWillDeliver: "the project will deliver",
    theReceiverWants: "For this output, the receiver and user want",
    willConfirm: "will confirm that we have",
    by: "by"
  },
  output: {
    title: "Output",
    fields: {
      output: {
        title: "Output",
        help: `When the project is done, which deliverable needs to be ready and handed over to someone else for permanent ownership?`,
        description: "Enter a high level output the project needs to deliver as part of this scope element"
      },
      qualityExpectation: {
        title: "Customer's Quality Expectation",
        help: `Any high level requirements from the user or customer?
          When the ownership of this deliverable is handed over from the project to the permanent
          owner, what expectations will the permanent owner have to the characteristics of this output.`,
        description: "Descrive the high level requirement for this output"
      }
    }
  },
  acceptance: {
    title: "Acceptance",
    fields : {
      acceptanceCriteria: {
        title: "Acceptance Criteria",
        help:`What exactly need to be in place for this output to be judged as completed?
          Which measurement, standard or specific characteristic?
          Is there any tolerance on this measurement or standard?`,
        description:"The measurable definition for acceptance of the required and any tolerance that might apply"
      },
      acceptanceMethod: {
        title: "Acceptance Method",
        help:`How will we decide that the output is good enough?
          Will we test, validate, review it or will someone just inspect and confirm?`,
        description:"The method used to confirm that the output meets the acceptance criteria"
      },
      acceptanceResponsible: {
        title: "Acceptance Responsible",
        help:`Who is responsible for confirming acceptance?
          Who has the authority to say “yes, this is good enough”?`,
        description:"The responsible of confirming"
      }
    }
  },
  dependencies: {
    title: "Dependencies",
    fields: {
      derivation: {
        title: "Derivation",
        help:`Are there any:
          - reports used as input ?
          - mandates, design specifications or more detailed requirement descriptions?
          - existing product to build on?`,
        description:"Describe source product for this output"
      },
      skills: {
        title: "Development skills required",
        help:`Any special skills needed worth mentioning?
          Which department, partner or vendor is needed to provide the needed skillset?`,
        description:"Give an indication of the skills required and/or which area should supply the resources"
      }
    }
  },
  projectProductDescription: {
    title:"Project Product Description",
    description: `The Project Product Description defines the final output of the project. It reflects the highest level of requirements. The high level outputs listed here can be further broken down in a product hierarchy to the level needed for planning and controlled execution.`,
    fields: {
      scopeDetails: {
        title:"Scope composition",
        columns: {
          output: { title:"Composition / Output" },
          qualityExpectation: { title:"Quality Expectations" },
          acceptanceCriteria: { title:"Acceptance Criteria" },
          acceptanceMethod: { title:"Acceptance Method" },
        },
        samples: [
          {output: "&lt;Output 1&gt;"},
          {output: "&lt;Output 2&gt;"}
        ],
        empty: {
          message: "Scope is not defined. Please define scope in 'Definition' before you identify outputs."
        },
        options: {
          addEntry: {
            title: "Add output"
          }
        }
      }
    }
  },
  qualityManagementApproach: {
    title: "Quality Management Approach",
    description : "The quality management approach describes how to manage quality, including requirement management. What will we do to make sure the projects' products are “fit for purpose”?",
    fields:{
      process: {
        title: "Process and Procedures",
        help: `What method will be used to make sure the project:
               a) captures all relevant needs and requirements? 
               b) correctly prioritizes the needs and requirements?
               c) develops the correct design to meet those needs and requirements? 
               Are there any standard procedures to be followed on requirement management, testing, approvals etc.? Any planned deviation from these procedures? If so, why? 
               How will we make sure the quality procedure is followed – that approvals are tracked? 
               Is data privacy relevant for the project’s output, and should the project perform privacy impact assessment(s)?`,
        description:"Describe what processes will be followed to make sure all deliverables are fit for purpose."
      },
      tools : {
        title: "Tools and Techniques",
        help:`Which techniques (interviews, prototypes, workshops etc.) will be used, to ensure we are making the right product? 
              Where will needs and requirements be organized, detailed and prioritized? 
              Where will test plans, protocols and reports be organized and controlled?
              Any standards or templates to be used?
              Which techniques will be used to make sure we are making the product right? (reviews,tests) 
              Will a quality register be used? If yes, is it the only tool used to track quality actions and approvals? If no, what will be used instead?`,
        description: "Describe what tools or techniques will be applied to make sure all deliverables are fit for purpose."
      },
      reporting: {
        title: "Reporting",
        help: "When will quality be reported? Where will quality be reported and who will receive the quality reports?",
        description: "The reports to be produced, their purpose, timing and recipients."
      },
      timing: {
        title: "Timing of activities",
        help: "When will quality management activities occur? Any specific activities in Initiation or beginning/end of stages?",
        description: "Describe the timing of quality management activities"
      },
      roles:{
        title: "Roles and responsibilities",
        help: `Who approved Briefs, Plans, Product Descriptions ?
          Who makes sure detailed requirements are captured? Who approves them?
          Who calls and organizes quality management activities and reviews?
          Who makes test/review plans and reports?
          Who enters what in the quality register and who approves?`,
        description: "Define the roles and responsibilities for the activities"
      }
    }
  },
  products: {
    title: "Products"
  },
  qualityRegister: {
    title: "Quality Register"
  }
}



// WEBPACK FOOTER //
// ./views/quality/labels/english.js